import * as THREE from 'three'

import GlassBaseHole from './../glassBaseHole'
import MathsUtils from '@/utils/mathsUtils'
import EditorUtils from '@glass-designer/utils/editorUtils'

import GlassDesignerTypes from '../../types'


/*
 * OvalHole
 * Simple oval hole with a width/height
 */
export default class OvalHole extends GlassBaseHole {
  constructor(editor, options = {}) {
    super(editor, options)
    this.objectClassName = 'OvalHole'
    
    this.name = 'Oval Center Cutout'
    this.holeType = GlassDesignerTypes.LibraryItemShapeTypes.oval
    
    this.width = options.width || 50
    this.height = options.height || 30

    this.rebuildHoleShape()
  }

  dispose() {
    super.dispose()
  }


  /**
   * Update the center cutout settings
   */
  updateCutoutSettings(info) {
    if(info.width !== undefined)
      this.width = parseFloat(info.width || 0)
    if(info.height !== undefined)
      this.height = parseFloat(info.height || 0)

    super.updateCutoutSettings(info)
  }


  /**
   * Rebuilds the hole segments based on the basic width/height of the rectangle hole
   * Only to be used when first creating the hole
   */
  rebuildHoleShape() {
    var startX = 0
    var startY = 0

    // Update via datum links
    this.updateDatumLinkWorldPoint()
    startX = this.worldPoint.x - this.anchorPoint.x
    startY = this.worldPoint.y - this.anchorPoint.y

    if(this.datumDisplayPointObj)
      this.datumDisplayPointObj.setPosition(this.worldPoint)

    let center = new THREE.Vector2(startX + this.width/2, startY + this.height/2)
    this.segmentList = EditorUtils.generateSegmentsForOval(center, this.width, this.height)

    MathsUtils.segmentListUpdated(this.segmentList)
    
    this.updateSceneObject()
  }


  /**
   * Update the selection display object from the hole shape segments
   * Called when rebuilding the hole shape
   */
   updateSceneObject() {
    super.updateSceneObject()
  }


  /**
   * Checks if a 2D circle intersects with the oval hole
   * Returns true if an intersection occurred & sets the closest point on the hole the point is to
   */
  check2DCircleIntersection(point, radius, outIntPoint) {
    let bounds = this.calculateSegmentBounds()
    let center = bounds.getCenter(new THREE.Vector2())

    let distance = center.distanceTo(point)
    let minRadius = Math.min(this.width/2, this.height/2)

    // Inside the min radius?
    if(distance <= minRadius) {
      outIntPoint.set(point.x, point.y)
      return true
    }

    // Within the intersecting oval radius
    // Note: Only an approximation ignoring the circle radius
    var p = (parseInt(Math.pow((point.x - center.x), 2)) / parseInt(Math.pow(this.width/2, 2))) + (parseInt(Math.pow((point.y - center.y), 2)) / parseInt(Math.pow(this.height/2, 2)));
    if(p <= 1) {
      outIntPoint.set(point.x, point.y)
      return true
    }

    return false
  }

  /**
   * Clone the circle hole
   */
  clone() {    
    var newHole = new OvalHole(this.editor)
    newHole.copy(this)

    return newHole
  }


  /**
   * Copy details from a circle hole to this circle hole
   */
  copy(otherHole) {
    super.copy(otherHole)
    
    this.width = otherHole.width
    this.height = otherHole.height

    this.rebuildHoleShape()
  }


  // Serialize/Deserialize to/from a JSON object
  serialize() {
    var objData = super.serialize()

    objData.width = this.width
    objData.height = this.height

    return objData
  }
  deserialize(object) {
    super.deserialize(object)

    this.width = parseFloat(object.width || 50)
    this.height = parseFloat(object.height || 30)

    this.holeSizeUpdated()
    this.rebuildHoleShape()
  }
}
